export default function () {
  return <div className="h-screen bg-orange-400">help center</div>;
}
